import { Box } from "@mui/material";
import Header from "../Header";
import GigLayout from "./GigLayout";

const GigModePage = () => {
  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />
      <GigLayout />
    </Box>
  );
};

export default GigModePage;
